export const breakpoints = {
    mobile: '500px',
    tablet: '768px',
};



// WEBPACK FOOTER //
// ./src/constants.js